import React, { useState, useMemo } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const maxDots = 5;

const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    appendDots: (dots) => (
        <div>
            <ul className="flex justify-center">{dots.slice(0, maxDots)}</ul>
        </div>
    ),
    responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        { breakpoint: 640, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
};

const Reviews = ({ testimonials = [], reviews = [], plus = false }) => {
    const [expandedIndex, setExpandedIndex] = useState(null);

    const toggleReadMore = (index) => {
        setExpandedIndex(expandedIndex === index ? null : index);
    };

    return (
        <section className="container-1280 py-12 xl:min-w-[70%] lg:min-w-[90%] w-[95%] m-auto">
            <h2 className="mb-6 text-4xl font-bold text-center lg:text-center">
                What Our Clients Say
            </h2>
            <Slider
                {...sliderSettings}
                className="mx-0 md:mx-[40px] lg:mx-[60px] xl:mx-[10px]"
            >
                {testimonials.map((item, index) => {
                    const isExpanded = expandedIndex === index;

                    return (
                        <div key={index}>
                            <div
                                className={`p-6 bg-[#ececec] border-b-4 border-red-500 rounded-lg shadow-xl w-[85vw] sm:w-[300px] md:w-[350px] lg:w-[400px] ${plus
                                    ? "min-h-[250px] md:min-h-[250px]"
                                    : "min-h-[250px] md:min-h-[250px]"
                                    }`}
                            >
                                <div className="flex items-center mb-4">
                                    <div className="flex items-center justify-center w-12 h-12 bg-white rounded-full">
                                        <img src={item.img} alt={item.name} />
                                    </div>
                                    <h3 className="ml-3 text-lg font-bold text-red-600">
                                        {item.name}
                                    </h3>
                                </div>
                                <p className="text-[14px] text-gray-700 text-md text-center">
                                    {item.text.length > 150 && !isExpanded
                                        ? `"${item.text.slice(0, 150)}..."`
                                        : `"${item.text}"`}
                                </p>
                                {item.text.length > 150 && (
                                    <button
                                        onClick={() => toggleReadMore(index)}
                                        className="block mx-auto mt-2 text-sm font-semibold text-red-600 underline focus:outline-none"
                                    >
                                        {isExpanded ? "Read Less" : "Read More"}
                                    </button>
                                )}
                            </div>
                        </div>
                    );
                })}
            </Slider>
            <div className="w-full h-px mt-10 bg-gray-800 lg:mt-20"></div>
        </section>
    );
};

export default Reviews;